import React, { useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";


//Components
import LandingPage from './components/_index';
import NoMatch from "./components/layout/NoMatch";
import Login from './components/login/Login';
import Transactions from './components/transactions/Transactions';
import TransactionsTemporal from "./components/transactions/TransactionTemporal";
import Buys from "./components/Buys/Buys";
import AnaliticStore from "./components/analitics/AnaliticStore";
import ReportStore from "./components/reports/ReportStore";
import Events from "./components/Events/Events";
import ProductStore from "./components/products/ProductStore";
import SmartpayWebhook from './components/Webhook/Webhook.jsx'
import Users from "./components/Users/Users.jsx";
import VendingPanel from "./components/Vending/VendingPanel.jsx";
import Machines from "./components/Machines/Machines.jsx";
import Inventory from "./components/Inventory/Inventory.jsx";
import Notifications from "./components/Notifications/Notifications.jsx";
import RoomsTables from "./components/RoomsTables/RoomsTables.jsx";
import Cupons from "./components/Cupons/Cupons.jsx";
import BankConsiliation from "./components/BankConsiliation/BankConsiliation.jsx";
import ErrorAlert from "./components/Alerts/ErrorAlert.jsx";
import FrecuentClient from "./components/FrecuentClient/FrecuentClient.jsx";
import EcommerceManager from "./components/Ecommerce/EcommerceManager.jsx";
import DeliveryManagement from "./components/Delivery/DeliveryManager.jsx";
import PickAndGoManager from "./components/PickAndGo/PickAndGoManager.jsx";
import Clients from "./components/Clients/Clients.jsx";
import RulesByEvent from "./components/Events/Rules/RulesByEvent.jsx";
//Integrations managment 
import IntegrationManager from "./components/integrations/IntegrationManager.jsx";

//API 
import { AuthFetchAPI } from "./api/Auth";
import { MobilePushFetchAPI } from "./api/MobilePush";
import {
  getStoredAppInstanceId,
  getStoredFcmToken,
  getStoredSessionId,
  installAndroidSessionBridge,
  isPushEnabled,
  notifyAndroidDashboardReady
} from "./utils/AndroidSessionBridge";

//context 
import UserContext from "./context/UserContext";
import { BranchProvider } from "./context/BranchContext";


//CSS
import './assets/css/buttons.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
import './index.css';

//Utils
import ToastContainer from "./utils/toast/ToastContainer";

import 'bootstrap-icons/font/bootstrap-icons.css'

import SupportAdmin from "./new_version/components/SupportBot/SupportAdmin/SupportAdmin.jsx";

//New Version Imports 
import Overview from "./new_version/page/Overview/Overview.jsx";
import ProductPanel from "./new_version/components/ProductPanel/ProductPanel.jsx";
import ReportsPanel from "./new_version/page/Reports/ReportsPanel.jsx";
import TransactionsPanel from "./new_version/components/transactions/Transactions";
import PrecuentasPanel from "./new_version/components/transactions/PrecuentasPanel";

import NewEcommerceManager from "./new_version/components/Ecommerce/EcommerceManager";
import NewInventory from "./new_version/components/Inventory/Inventory";
import NewBuys from "./new_version/components/Buys/Buys";
import NewAnaliticStore from "./new_version/components/analitics/AnaliticStore";

import NewEvents from "./new_version/components/Events/Events";

import NewVendingPanel from "./new_version/components/Vending/VendingPanel.jsx";
import NewMachines from "./new_version/components/Machines/Machines.jsx";
import NewNotifications from "./new_version/components/Notifications/Notifications.jsx";
import NewRoomsTables from "./new_version/components/RoomsTables/RoomsTables.jsx";
import NewTableRequests from "./new_version/components/RoomsTables/TableRequests.jsx";
import NewCupons from "./new_version/components/Cupons/Cupons.jsx";
import NewBankConsiliation from "./new_version/components/BankConsiliation/BankConsiliation.jsx";
import NewErrorAlert from "./new_version/components/Alerts/ErrorAlert.jsx";
import NewFrecuentClient from "./new_version/components/FrecuentClient/FrecuentClient.jsx";

import NewDeliveryManagement from "./new_version/components/Delivery/DeliveryManager.jsx";
import NewPickAndGoManager from "./new_version/components/PickAndGo/PickAndGoManager.jsx";

import NewyWebhook from './new_version/components/Webhook/Webhook.jsx'
import NewUsers from "./new_version/components/Users/Users.jsx";
import NewClients from "./new_version/components/Clients/Clients.jsx";
import NewPrecuentasPanel from "./new_version/components/transactions/TransactionTemporal";


///auth/token
function App() {


  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined
  });

  const hasAndroidFcmBridge = () => {
    return typeof window !== "undefined" &&
      ((window.AndroidBridge && window.AndroidBridge.getFcmToken) || getStoredFcmToken());
  }

  const callAndroidBridge = (methodName) => {
    try {
      if (!window.AndroidBridge || typeof window.AndroidBridge[methodName] !== "function") {
        return null;
      }

      return window.AndroidBridge[methodName]();
    } catch (err) {
      return null;
    }
  }

  const getFallbackAppInstanceId = () => {
    const storageKey = 'smartpay_android_app_instance_id';
    const storedAppInstanceId = localStorage.getItem(storageKey);

    if (storedAppInstanceId) {
      return storedAppInstanceId;
    }

    const appInstanceId = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `webview-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    localStorage.setItem(storageKey, appInstanceId);
    return appInstanceId;
  }

  const getAccessTokenHash = (token) => {
    if (!token) {
      return null;
    }

    return `${token.length}:${token.slice(0, 12)}:${token.slice(-12)}`;
  }

  const getAndroidForeground = () => {
    const bridgeForeground = callAndroidBridge('getAppForeground');

    if (bridgeForeground === null || bridgeForeground === undefined || bridgeForeground === '') {
      return document.visibilityState !== 'hidden';
    }

    return bridgeForeground === true || bridgeForeground === 'true' || bridgeForeground === '1' || bridgeForeground === 1;
  }

  const getAndroidSessionPayload = () => {
    const bridgePayload = callAndroidBridge('getSessionPayload') || callAndroidBridge('getSmartPaySession');

    if (!bridgePayload) {
      return null;
    }

    if (typeof bridgePayload === 'string') {
      try {
        return JSON.parse(bridgePayload);
      } catch (err) {
        return null;
      }
    }

    return bridgePayload;
  }

  const getAndroidPushContext = () => {
    if (!hasAndroidFcmBridge()) {
      return null;
    }

    const token = localStorage.getItem('x-access-token');
    const rawUser = localStorage.getItem('user');

    if (!token || !rawUser) {
      return null;
    }

    if (!isPushEnabled()) {
      return null;
    }

    const deviceToken = callAndroidBridge('getFcmToken') || getStoredFcmToken();
    if (!deviceToken || String(deviceToken).trim() === '') {
      return null;
    }

    const user = JSON.parse(rawUser);
    if (!user || !user.id) {
      return null;
    }

    const appInstanceId = callAndroidBridge('getAppInstanceId') || getStoredAppInstanceId() || getFallbackAppInstanceId();
    const sessionId = callAndroidBridge('getSessionId') || getStoredSessionId() || null;
    const accessTokenHash = sessionId ? null : getAccessTokenHash(token);

    return {
      token,
      user,
      data: {
        token: String(deviceToken),
        fcm_token: String(deviceToken),
        platform: 'android',
        app_source: 'smartpay-webview',
        app_instance_id: appInstanceId,
        session_id: sessionId,
        access_token_hash: accessTokenHash,
        business_id: user.business?.id || user.business_id || null,
        business_code: user.business?.code || null,
        user_id: user.id,
        branchoffice_codes: Array.isArray(user.branchoffices)
          ? user.branchoffices.map((branch) => branch.code).filter(Boolean)
          : [],
        foreground: getAndroidForeground()
      }
    };
  }

  const registerAndroidFcmToken = async (force = false) => {
    try {
      const pushContext = getAndroidPushContext();
      if (!pushContext) {
        return;
      }

      const registrationFingerprint = [
        pushContext.token,
        pushContext.user.id,
        pushContext.data.token,
        pushContext.data.app_instance_id,
        pushContext.data.session_id || pushContext.data.access_token_hash
      ].join(':');

      if (!force && localStorage.getItem('smartpay_fcm_registration') === registrationFingerprint) {
        return;
      }

      await MobilePushFetchAPI.registerDeviceToken(pushContext.data, pushContext.token);

      localStorage.setItem('smartpay_fcm_registration', registrationFingerprint);
    } catch (err) {
      console.log('FCM device token registration skipped', err);
    }
  };

  const sendAndroidFcmHeartbeat = async (foreground = true) => {
    try {
      const pushContext = getAndroidPushContext();
      if (!pushContext) {
        return;
      }

      await MobilePushFetchAPI.heartbeatDeviceToken({
        ...pushContext.data,
        foreground
      }, pushContext.token);
    } catch (err) {
      console.log('FCM device token heartbeat skipped', err);
    }
  }

  const sendAndroidFcmBackground = async () => {
    try {
      const pushContext = getAndroidPushContext();
      if (!pushContext) {
        return;
      }

      await MobilePushFetchAPI.backgroundDeviceToken({
        ...pushContext.data,
        foreground: false
      }, pushContext.token);
    } catch (err) {
      console.log('FCM device token background skipped', err);
    }
  }


  //Function to check if the user is logged in or available
  const checkLogin = async () => {
    let token = localStorage.getItem('x-access-token');
    let machineToken = localStorage.getItem('x-access-machine-token');

    let user = localStorage.getItem('user');
    //We get the url
    let actualPage = window.location.href;

    //We check if the user has the token 
    if (token == null) {
      localStorage.setItem('x-access-token', '');
      token = ''
    }
    //We check if the machine has the token
    if (machineToken == null) {
      localStorage.setItem('x-access-machine-token', '');
      machineToken = ''
    }
    //We check if the token of the machine and user token is available (this is just for post cases)
    if (machineToken != '' && token != '') {
      try {
        //We check if the machine token is valid 
        const tokenMachineRes = await AuthFetchAPI.validtoken(machineToken);
        //We check if the user token is valid 
        const tokenres = await AuthFetchAPI.validtoken(token);
        //If the token is from kiosk we redirect to the kiosk page
        if ((tokenres.data === false || tokenMachineRes.data === false) && actualPage.includes("payments")) {
          localStorage.setItem('x-access-machine-token', '');
          machineToken = ''
          localStorage.setItem('x-access-token', '');
          token = ''
          window.location.reload()
        }

        // We check if the token is valid
        if (tokenres.data === true && actualPage.includes('payments')) {
          const user = await AuthFetchAPI.me(token);
          setUserData({ token: token, user: user.data })
        }
      } catch (error) {
        localStorage.setItem('x-access-machine-token', '');
        machineToken = ''
        localStorage.setItem('x-access-token', '');
        token = ''
        window.location.reload()
      }
    }

    //We check if the token of the machine is available (this is just for kiosk cases)
    if (machineToken != '') {
      try {
        //We check if the token is valid
        const tokenres = await AuthFetchAPI.validtoken(machineToken);
        //If the token is from kiosk we redirect to the kiosk page
        if (tokenres.data === false && actualPage.includes("kiosk")) {
          localStorage.setItem('x-access-machine-token', '');
          machineToken = ''
        }
      } catch (error) {
        //If the token is not valid we redirect to the login page
        if (actualPage.includes("kiosk")) {
          localStorage.setItem('x-access-machine-token', '');
          machineToken = ''
        }
      }
    }

    //We check if the token is available (this is for the user token and vending cases)
    if (token != '') {
      try {
        //We check if the token is valid
        const tokenres = await AuthFetchAPI.validtoken(token);
        //-------------

        if (tokenres.data === false) {
          ErrorAlert('Error', 'The token is not valid, please login again', 'error')
          setTimeout(() => {
            localStorage.setItem('x-access-token', '');
            token = ''

            user = JSON.parse(localStorage.getItem('user'))
            //We recharge the page
            window.location.href = `/login/${user.business.code}`;
          }, 3000)
        }
        //------------

        //If the token is not valid we redirect to the login page


      } catch (error) {

        ErrorAlert('Error', 'The token is not valid, please login again', 'error')
        setTimeout(() => {
          localStorage.setItem('x-access-token', '');
          token = ''

          user = JSON.parse(localStorage.getItem('user'))
          //We recharge the page
          window.location.href = `/login/${user.business.code}`;
        }, 3000)

      }
    }
  }

  useEffect(() => {
    const androidSessionBridge = installAndroidSessionBridge();

    const handleAndroidSessionApplied = async (event) => {
      const session = event.detail || {};
      const token = session.token || localStorage.getItem('x-access-token');
      const user = session.user || JSON.parse(localStorage.getItem('user') || 'null');
      const businessCode = session.business_code || user?.business?.code;

      if (token && user) {
        setUserData({ token, user });
        await registerAndroidFcmToken(true);
      }

      if (businessCode && window.location.pathname === `/transactions/${businessCode}`) {
        notifyAndroidDashboardReady();
      }

      if (session.target_url) {
        const targetUrl = new URL(session.target_url, window.location.origin);
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const targetPath = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;

        if (targetPath !== currentPath) {
          window.location.href = targetPath;
        }

        return;
      }

      if (businessCode && (window.location.pathname === '/' || window.location.pathname.startsWith('/login'))) {
        window.location.href = `/transactions/${businessCode}`;
      }
    };

    window.addEventListener('smartpay:android-session-applied', handleAndroidSessionApplied);
    const bridgePayload = getAndroidSessionPayload();
    if (bridgePayload && androidSessionBridge) {
      androidSessionBridge.applySession(bridgePayload);
    }

    (async () => {
      try {
        await checkLogin()
        await registerAndroidFcmToken(true)
      } catch (err) {
        console.log(err)
      }
    })()

    return () => {
      window.removeEventListener('smartpay:android-session-applied', handleAndroidSessionApplied);
    };
  }, [])

  useEffect(() => {
    (async () => {
      await registerAndroidFcmToken(true);
    })();
  }, [userData]);

  useEffect(() => {
    if (!hasAndroidFcmBridge()) {
      return;
    }

    let heartbeatInterval = null;
    let heartbeatActive = false;

    const startHeartbeat = async () => {
      if (heartbeatActive) {
        return;
      }

      heartbeatActive = true;
      heartbeatInterval = setInterval(() => {
        if (heartbeatActive) {
          sendAndroidFcmHeartbeat(true);
        }
      }, 30000);

      await registerAndroidFcmToken();
      if (heartbeatActive) {
        await sendAndroidFcmHeartbeat(true);
      }
    }

    const stopHeartbeat = () => {
      heartbeatActive = false;
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
        heartbeatInterval = null;
      }
    }

    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'hidden') {
        stopHeartbeat();
        await sendAndroidFcmBackground();
        return;
      }

      stopHeartbeat();
      await startHeartbeat();
    }

    startHeartbeat();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopHeartbeat();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userData]);

  return (
    <>
      <Router>
        <UserContext.Provider value={{ userData, setUserData }}>
          <BranchProvider>
          <Routes>
            {/* Index Main Menu  */}
            <Route exact path="/" element={<Login />} />
            {/* Logins */}
            <Route path="/login/:business_code" element={<Login />} />
            {/**Transaction of admins */}
            <Route path="/transactions/:business_code" element={<Transactions />} />
            <Route path="/analitics/:business_code" element={<AnaliticStore />} />
            <Route path="/reports/:business_code" element={<ReportStore />} />
            <Route path="/bank/consiliation/:business_code" element={<BankConsiliation />} />
            {/** Users */}
            <Route path="/users/:business_code" element={<Users />} />
            {/** Buys */}
            <Route path="/buys/:business_code" element={<Buys />} />
            {/** Products of admins */}
            <Route path="/products/:business_code" element={<ProductStore />} />
            {/** Clients */}
            <Route path="/clients/:business_code" element={<Clients />} />
            {/** Temporal transactions */}
            <Route path="/temporal/:business_code" element={<TransactionsTemporal />}></Route>
            {/**Smartpay Webhook  */}
            <Route path="/webhook/:business_code" element={<SmartpayWebhook></SmartpayWebhook>}></Route>
            {/** Integration of admins */}
            <Route path="/manager/integration/:business_code/:integration/:integrationId" element={<IntegrationManager />} />
            {/** Vending Panel */}
            <Route path="/vending/:business_code" element={<VendingPanel />} />
            {/** Events */}
            <Route path="/events/:business_code" element={<Events />} />

            {/** Machines */}
            <Route path="/machines/:business_code" element={<Machines />} />
            {/**Support bot admin */}
            <Route path="/support" element={<SupportAdmin />} />
            {/** Inventory */}
            <Route path="/inventory/:business_code" element={<Inventory />} />
            {/* Notifications */}
            <Route path="/notifications/:business_code" element={<Notifications />} />
            {/* Tables rooms */}
            <Route path="/tables/:business_code" element={<RoomsTables />} />
            {/* Cupons */}
            <Route path="/cupons/:business_code" element={<Cupons />} />
            {/* Frecuent client */}
            <Route path="/config/frecuent-client/:business_code" element={<FrecuentClient />} />
            {/** Ecommerce Manager */}
            <Route path="/config/ecommerce/:business_code" element={<EcommerceManager />} />
            {/** Delivery Management */}
            <Route path="/config/delivery/:business_code" element={<DeliveryManagement />} />
            {/** Pick and Go Management */}
            <Route path="/config/pick-and-go/:business_code" element={<PickAndGoManager />} />

            {/** Rules by event by id*/}
            <Route path="/rules/event/:event_id" element={<RulesByEvent />} />
            {/** Rules by event */}
            <Route path="/rules/event" element={<RulesByEvent />} />
            {/* No Match link */}
            <Route path="*" element={<NoMatch />} />



            {/* New Version Routes */}
            {/** ******* **/}
            <Route path="/overview/:business_code" element={<Overview />} />
            <Route path="/product_panel/:business_code" element={<ProductPanel />} />
            <Route path="/report_panel/:business_code" element={<ReportsPanel />} />
            <Route path="/transactions_panel/:business_code" element={<TransactionsPanel />} />
            <Route path="/precuentas_panel/:business_code" element={<NewPrecuentasPanel />} />
            <Route path="/settings_panel/:business_code" element={<PrecuentasPanel />} />
            <Route path="/config/new_ecommerce/:business_code" element={<NewEcommerceManager />} />

            <Route path="/new_inventory/:business_code" element={<NewInventory />} />
            <Route path="/new_buys/:business_code" element={<NewBuys />} />
            <Route path="/new_analitics/:business_code" element={<NewAnaliticStore />} />
            <Route path="/new_events/:business_code" element={<NewEvents />} />





            {/** Users */}
            <Route path="/new_users/:business_code" element={<NewUsers />} />

            {/** Vending Panel */}
            <Route path="/new_vending/:business_code" element={<NewVendingPanel />} />


            {/** Machines */}
            <Route path="/new_machines/:business_code" element={<NewMachines />} />
            {/**Support bot admin */}
            <Route path="/new_support" element={<SupportAdmin />} />
            {/** Inventory */}
            <Route path="/new_inventory/:business_code" element={<NewInventory />} />
            {/* Notifications */}
            <Route path="/new_notifications/:business_code" element={<NewNotifications />} />
            {/* Tables rooms */}
            <Route path="/new_tables/:business_code" element={<NewRoomsTables />} />
            {/* Table access requests (ecommerce) */}
            <Route path="/new_tables/requests/:business_code" element={<NewTableRequests />} />
            {/* Cupons */}
            <Route path="/new_cupons/:business_code" element={<NewCupons />} />
            {/* Frecuent client */}
            <Route path="/config/new_frecuent-client/:business_code" element={<NewFrecuentClient />} />

            {/** Delivery Management */}
            <Route path="/config/new_delivery/:business_code" element={<NewDeliveryManagement />} />
            {/** Pick and Go Management */}
            <Route path="/config/new_pick-and-go/:business_code" element={<NewPickAndGoManager />} />

            {/**Smartpay Webhook  */}
            <Route path="/new_webhook/:business_code" element={<NewyWebhook></NewyWebhook>}></Route>

            {/** Clients */}
            <Route path="/new_clients/:business_code" element={<NewClients />} />
            <Route path="/bank/new_consiliation/:business_code" element={<NewBankConsiliation />} />
          </Routes>
          </BranchProvider>
        </UserContext.Provider>
      </Router>

      <ToastContainer />
    </>
  );
}

export default App;
